// extracted by mini-css-extract-plugin
export default {"wave":"lsf-wave","wave__loader":"lsf-wave__loader","wave__loader_animated":"lsf-wave__loader_animated","waiting":"lsf-waiting","wave__wrapper":"lsf-wave__wrapper","wave__scale":"lsf-wave__scale","wave__body":"lsf-wave__body","wave__cursor":"lsf-wave__cursor","wave__controls":"lsf-wave__controls","wave__surfer":"lsf-wave__surfer","wave__timeline":"lsf-wave__timeline"};
    if(module.hot) {
      // 1653630385796
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  